import * as React from 'react';
import { cn } from './lib/utils';

const DOMAIN_COLOR = {
  staffing: 'var(--yellow)',
  quality:  'var(--royal)',
  access:   'var(--aqua)',
  finance:  'var(--green)',
  consumer: 'var(--orange-warn)',
  health:   'var(--teal-dark)',
};

/**
 * 7px coloured dot used in sidebar nav items.
 * Pass `domain` for auto-colour or `color` for a custom CSS value.
 */
function DomainDot({ domain, color, size = 7, className }) {
  const bg = color ?? DOMAIN_COLOR[domain] ?? 'var(--aqua)';
  return (
    <span
      className={cn('inline-block rounded-full shrink-0', className)}
      style={{ width: size, height: size, background: bg }}
      aria-hidden="true"
    />
  );
}

export { DomainDot };
